.section {
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  max-width: 1600px;
  box-sizing: border-box;
  gap: 60px;

  background-color: var(--section-background-color);
  --section-background-color: var(--cms-section-background-color-white);

  @include mainPadding();

  &.grey {
    --section-background-color: var(--cms-section-background-color-grey);
  }

  ::slotted(lilu-swiper) {
    --swiper-background-color: var(--section-background-color);
  }

  &.white {
    ::slotted(lilu-title) {
      margin-bottom: -30px;
    }
  }

  ::slotted(lilu-breadcrumb) {
    margin-top: -45px;
    margin-bottom: -30px;

    @include breakpointMin('lg') {
      margin-bottom: unset;
    }
  }

  ::slotted(*:first-child) {
    padding-top: 60px; // default
  }

  ::slotted(lilu-swiper:first-child) {
    padding-top: 0;
    margin-top: 60px;
  }

  ::slotted(lilu-hero-slider:first-child) {
    /*
      Remove padding to the top if the hero slider is the first item in a cms section
      Unset the padding with a minus margin
    */
    margin-top: -60px;
  }

  ::slotted(*:last-child) {
    padding-bottom: 60px;
  }

  ::slotted(lilu-newsletter) {
    @include fullWidth();
  }

  /*
    Remove padding to the bottom if the newsletter item is the last in a cms section
    Unset the padding with a minus margin
  */
  ::slotted(lilu-newsletter:last-child) {
    margin-bottom: -60px;
  }

  ::slotted(lilu-newsletter:first-child) {
    margin-top: -60px;
  }

  ::slotted(lilu-hero-slider) {
    @include fullWidth();
  }

  ::slotted(lilu-hr) {
    margin-bottom: -40px;
  }

  ::slotted(lilu-cms-product-banner) {
    @include fullWidth();
  }
}
